module.exports = __webpack_public_path__ + "img/logo2.f6ef9c8c.png";